import { html, SYSBaseElement } from "../../../../../../_ovlclient/src"
import type { SYSTableDefIds } from "../../../../../../_ovlclient/src"
import { T } from "../../../../../../_ovlclient/src/textapi"
export class ScreenSymbolPC extends SYSBaseElement {
  async getUI() {
    return html`
      <div
        class="ovl-smart-screen-margins-lr-large ovl-smart-padding-lr-symmetrical"
      >
        <div class="fd-layout-panel ">
          <div class="fd-layout-panel__header">
            <div class="fd-layout-panel__head">
              <h3 class="fd-layout-panel__title">${T("SPCSymbolPCAdmin")}</h3>
            </div>
          </div>

          <div
            class="fd-layout-panel__body fd-has-padding-base fd-has-margin-base"
          >
            <ovl-table
              class="fd-table"
              .props=${() => <SYSTableDefIds>"SPCSymbolPC"}
            >
            </ovl-table>
          </div>
        </div>
      </div>
    `
  }
}
